import { Paragraph } from '@zillow/constellation-10';
import PropTypes from 'prop-types';

interface Props {
  remainingAttempts: number;
}

const TryAgainPage = ({ remainingAttempts }: Props): JSX.Element | null => (
  <>
    <Paragraph textStyle="body-lg-bold">Your identity was not verified</Paragraph>
    <Paragraph>Some of your answers were incorrect so we could not verify your identity.</Paragraph>
    <Paragraph>Please try again. You have {remainingAttempts} attempts left.</Paragraph>
  </>
);

TryAgainPage.propTypes = {
  remainingAttempts: PropTypes.number.isRequired,
};

export default TryAgainPage;
